/**
 * @file
 * A higher-order component used to pull TournamentType off URL params
 */

import * as React from 'react';
import 'url-search-params-polyfill';

// Types
import { IWithTournamentType, TournamentType } from '../types';

const withTournamentTypeFromParams = <P extends object>(
  Component: React.ComponentType<P>
) =>
  class WithTournamentTypeFromParams extends React.PureComponent<
    P & IWithTournamentType
  > {
    // Initialize to TournamentType.Pro (1)
    public type = TournamentType.PRO;

    constructor(props: P & IWithTournamentType) {
      super(props);

      // Pull pro/co off URL, ie ?pro=1|?pro=0|?co=1. Original logic is:
      //   "If pro is anything besides '0' (string), type is PRO (1), else CO (0)
      this.type =
        new URLSearchParams(window.location.search).get('pro') !== '0'
          ? TournamentType.PRO
          : TournamentType.CO;
    }

    public render() {
      const props = {
        ...this.props,
        type: this.type,
      };

      return <Component {...props} />;
    }
  };

export default withTournamentTypeFromParams;
